import { useNavigate } from "react-router-dom";

const NAV_LINKS = ["Home", "Services", "Plans", "How It Works", "Contact"];

export default function DeleteAccount() {
  const navigate = useNavigate();

  const goHome = (id) => {
    navigate("/");
    // allow the home page to mount before trying to scroll to a section
    if (id) {
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        color: "#1E293B",
        overflowX: "hidden",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ── NAV ── */}
      <nav
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          background: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(12px)",
          boxShadow: "0 1px 20px rgba(0,0,0,0.08)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 5%",
          height: 68,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            cursor: "pointer",
          }}
          onClick={() => goHome()}
        >
          <div
            style={{
              width: 35,
              height: 35,
              borderRadius: 8,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#fff",
            }}
          >
            <img
              src="/logo.jpeg"
              alt="logo"
              style={{
                width: "275%",
                height: "275%",
                objectFit: "contain",
              }}
            />
          </div>
        </div>

        {/* Desktop Links */}
        <div
          style={{ display: "flex", gap: 32, alignItems: "center" }}
          className="desktop-nav"
        >
          {NAV_LINKS.map((l) => (
            <span
              key={l}
              onClick={() => goHome(l.toLowerCase().replace(" ", "-"))}
              style={{
                cursor: "pointer",
                fontWeight: 600,
                fontSize: 14,
                color: "#475569",
                transition: "color .2s",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#3B82F6")}
              onMouseLeave={(e) => (e.target.style.color = "#475569")}
            >
              {l}
            </span>
          ))}
        </div>

        <button
          onClick={() => goHome("plans")}
          style={{
            background: "linear-gradient(135deg,#3B82F6,#8B5CF6)",
            color: "#fff",
            border: "none",
            padding: "10px 24px",
            borderRadius: 50,
            fontWeight: 700,
            cursor: "pointer",
            fontSize: 14,
            boxShadow: "0 4px 15px rgba(59,130,246,.35)",
          }}
        >
          Get Started
        </button>
      </nav>

      {/* ── MAIN CONTENT ── */}
      <main
        style={{
          flex: 1,
          paddingTop: 68,
          background: "#fff",
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "100px 24px 80px",
            maxWidth: 700,
            margin: "0 auto",
          }}
        >
          <h1 style={{ fontWeight: 600, fontSize: 28, marginBottom: 20 }}>
            Delete Your Account
          </h1>

          <p style={{ fontSize: "17px", color: "#1E293B", lineHeight: 1.7 }}>
            If you want to delete your account, please mail with your registred
            email id at{" "}
            <b style={{ color: "#3B82F6" }}>manoj.cleanup@gmail.com</b>
          </p>
        </div>
      </main>

      {/* ── FOOTER ── */}
      <footer
        style={{
          background: "#0F172A",
          color: "#94A3B8",
          padding: "48px 5% 28px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 32,
            marginBottom: 40,
          }}
        >
          <div style={{ maxWidth: 280 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  background: "linear-gradient(135deg,#3B82F6,#8B5CF6)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 18,
                }}
              >
                🚿
              </div>
              <span style={{ fontWeight: 800, fontSize: 18, color: "#fff" }}>
                ShineDrive
              </span>
            </div>
            <p style={{ fontSize: 14, lineHeight: 1.7 }}>
              Professional doorstep car wash services. Clean car, happy you —
              every time.
            </p>
          </div>
          <div>
            <div style={{ color: "#fff", fontWeight: 700, marginBottom: 14 }}>
              Services
            </div>
            {[
              "Quick Wash",
              "Deep Clean",
              "Premium Detail",
              "Glass & Tyre Care",
            ].map((s) => (
              <div
                key={s}
                style={{ marginBottom: 8, fontSize: 14, cursor: "pointer" }}
                onMouseEnter={(e) => (e.target.style.color = "#fff")}
                onMouseLeave={(e) => (e.target.style.color = "#94A3B8")}
              >
                {s}
              </div>
            ))}
          </div>
          <div>
            <div style={{ color: "#fff", fontWeight: 700, marginBottom: 14 }}>
              Company
            </div>
            {["About Us", "How It Works", "Pricing", "Blog", "Careers"].map(
              (s) => (
                <div
                  key={s}
                  style={{ marginBottom: 8, fontSize: 14, cursor: "pointer" }}
                  onMouseEnter={(e) => (e.target.style.color = "#fff")}
                  onMouseLeave={(e) => (e.target.style.color = "#94A3B8")}
                >
                  {s}
                </div>
              ),
            )}
          </div>
          <div>
            <div style={{ color: "#fff", fontWeight: 700, marginBottom: 14 }}>
              Download App
            </div>
            <StoreButton store="google" footer />
            <div style={{ height: 10 }} />
            <StoreButton store="apple" footer />
          </div>
        </div>
        <div
          style={{
            borderTop: "1px solid #1E293B",
            paddingTop: 24,
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
            fontSize: 13,
          }}
        >
          <span>© 2025 ShineDrive. All rights reserved.</span>
          <div style={{ display: "flex", gap: 20 }}>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => window.open("/terms-of-service", "_blank")}
            >
              Terms of Service
            </span>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => window.open("/privacy-policy", "_blank")}
            >
              Privacy Policy
            </span>
            <span style={{ cursor: "pointer" }}>Cookie Policy</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
function StoreButton({ store, dark, footer }) {
  const isGoogle = store === "google";
  const base = {
    display: "inline-flex",
    alignItems: "center",
    gap: 10,
    padding: footer ? "10px 16px" : "14px 24px",
    borderRadius: 12,
    border: dark ? "2px solid rgba(255,255,255,0.3)" : "2px solid #E2E8F0",
    background: dark ? "rgba(255,255,255,0.12)" : "#fff",
    color: dark ? "#fff" : "#1E293B",
    cursor: "pointer",
    textDecoration: "none",
    transition: "all .2s",
    minWidth: footer ? "auto" : 180,
  };
  return (
    <div
      style={base}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = dark
          ? "rgba(255,255,255,0.22)"
          : "#F8FAFC";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = dark
          ? "rgba(255,255,255,0.12)"
          : "#fff";
        e.currentTarget.style.transform = "none";
      }}
    >
      <span style={{ fontSize: footer ? 20 : 26 }}>{isGoogle ? "▶" : ""}</span>
      <div>
        <div style={{ fontSize: 10, opacity: 0.7, lineHeight: 1 }}>
          {isGoogle ? "GET IT ON" : "Download on the"}
        </div>
        <div style={{ fontWeight: 800, fontSize: footer ? 13 : 16 }}>
          {isGoogle ? "Google Play" : "App Store"}
        </div>
      </div>
    </div>
  );
}
